<template>
  <div class="d-flex align-center justify-space-between mb-13">
    <div class="page-select">
      <v-select class="page-select__box"
                :value="currentPage"
                :items="pages"
                item-text="title"
                item-value="value"
                append-icon="mdi-chevron-down"
                solo
                dense
                hide-details="true"
                hint="Dsd"
                @input="onChange">
        <template v-slot:prepend>
          <span class="clock-icon">
            Выберите:
          </span>
        </template>
      </v-select>
    </div>

    <ul class="short-info">
      <slot/>
    </ul>
  </div>
</template>

<script>
export default {
  data: (vm) => ({
    currentPage: { title: vm.$t('statistic.header.collectedData'), value: 'StatCollectedData' },

    pages: [
      { title: vm.$t('statistic.header.collectedData'), value: 'StatCollectedData' },
      { title: vm.$t('statistic.header.surveys'), value: 'StatSurveys' },
      { title: vm.$t('statistic.header.standmans'), value: 'StatStandmans' }
    ]
  }),

  methods: {
    onChange(e) {
      this.$router.push({ name: e })
    }
  },

  beforeMount() {
    this.currentPage = this.pages.find(item => item.value == this.$route.name);
  }
}
</script>

<style scoped>
  .page-select__box >>> .v-input__prepend-outer {
    margin: 0 !important;
  }

  .page-select__box >>> .v-input__slot {
    box-shadow: none !important;
    font-size: 12px;
    color: #2D9CDB;
  }

  .page-select__box >>> .v-select__selection {
    margin-top: 0;
  }

  .page-select__box >>> .v-select__selection {
    margin-top: 0 !important;
    color: #2D9CDB;
  }

  .page-select__box >>> .v-icon {
    color: #2D9CDB;
  }
</style>

<style lang="scss" scoped>
  .page-select {
    max-width: 275px;
  }

  .short-info {
    list-style: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: row;

    & span {
      font-size: 12px;
      font-weight: bold;
      color: #828282
    }
  }

  .short-info__item {
    margin-left: 25px;

    &:first-child {
      margin-left: 0;
    }
  }

  .icons {
    padding: 11px 30px 11px 0;
    margin-right: 10px;
    background-position: right center;
  }

  .clock-icon {
    padding: 11px 0 11px 30px;

    font-size: 12px;
    color: #2D9CDB;

    background-position: left center;
    background-image: url(/icons/clock-icon-20px-blue.svg);
  }

  .flag-icon {
    background-image: url(/icons/flag-icon-20px.svg);
  }

  .badge-icon {
    background-image: url(/icons/badge-icon-20px.svg);
  }

  .eye-icon {
    background-image: url(/icons/eye-icon-20px.svg);
  }

  .product-icon {
    background-image: url(/icons/product-icon-20px.svg);
  }

  .survey-icon {
    background-image: url(/icons/survey-icon-20px.svg);
  }
</style>
